(function ($) {
    "use strict";


    $(function () {

        objectFitImages();

        $('.js-search').on('click', function (e) {
            e.preventDefault();
            $('body').addClass('search-active');
            $('.js-search-overlay').addClass('active');

        });

        $('.js-search-close').on('click', function () {
            $('body').removeClass('search-active');
            $('.js-search-overlay').removeClass('active');
        });


        $('.js-done-select').SumoSelect({
            forceCustomRendering: true,
            floatWidth: 0,
        });

        $('.js-sidebar').stickySidebar({
            topSpacing: 0,
            bottomSpacing: 0,
            containerSelector: '.sidebar__container',
            innerWrapperSelector: '.plus-sidebar-wrapper',
            resizeSensor: true,
            minWidth: 992,
        });

        $('.sidebar__headline, .sidebar__arrow').on('click', function () {
            $('.sidebar__details').slideToggle();
            $('.sidebar__arrow').toggleClass('open');
        });

        $('.filter__titile__wrapper').on('click', function () {
            $(this).siblings('.options__search__wrapper').slideToggle();
            $(this).siblings('.minus__icon').toggleClass('open');
            $(this).siblings('.plus__icon').toggleClass('close');
        });

        $('.js-custom-select').SumoSelect({
            forceCustomRendering: true,
            floatWidth: 0
        });

        $('.js-filter-toggle').on('click', function (e) {
            e.preventDefault();
            $('.js-filter-toggle-wrapper').slideToggle();
        })

    });

})(jQuery);